import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, logged, ...rest }) => 
    <Route {...rest} render={ props => 
            logged ? <Component {...props} /> : <Redirect to="/" />
        }
    />

export default connect(state => ({ logged: state.auth.logged }), null)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js